import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { StarIcon } from "lucide-react";
import VideoTestimonials from "@/components/VideoTestimonials";

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      id: 1,
      name: "Centro de Medicina Americana",
      role: "",
      content: `Estávamos procurando uma empresa especializada na área da saúde, foi quando encontramos esse serviço de inteligência tributária da Tax Health, passamos a compreender como funciona a alíquota e constituição da nossa empresa.

Os profissionais são muito capacitados e sempre esclarecem todas as dúvidas de forma simples, a aplicação da inteligência resultou em uma economia muito expressiva, ajudando muito com o fluxo de caixa da empresa, foi nos apresentado o que a empresa havia pago indevidamente no passado e com nossa aprovação iniciamos o processo de solicitação de restituição.

Com certeza recomendamos o serviço, ótimos profissionais e uma empresa extremamente confiante.`,
      avatar: "https://taxhealthbr.com.br/wp-content/uploads/2023/10/648b6b446a53460c24e90f06.jpeg"
    },
    {
      id: 2,
      name: "Andreas Johann Jacob Hujn - Ortopedista",
      role: "",
      content: `Serviço personalizado para médicos, antes minha empresa pagava muitos impostos, depois de conhecer a Tax Health passei a ter uma grande economia, foi tudo muito simples, passei a economizar no mesmo mês que fiz a migração, serviço muito bom.`,
      avatar: "https://taxhealthbr.com.br/wp-content/uploads/2023/10/648b6b44ca594373aa3ee0a0.jpeg"
    },
    {
      id: 3,
      name: "Hugo Santiago - Ginecologista e Obstetra",
      role: "",
      content: `Meu primeiro contato com a Tax Health foi extremamente esclarecedor, finalizei a primeira reunião já com um conhecimento muito mais amplo, é impressionante como os profissionais são capacitados para explicar o serviço e tirar dúvidas.

Após a triagem foi diagnosticado que minha empresa estava pagando impostos indevidos, imediatamente foi corrigido e solicitado a restituição do que havia sido pago erroneamente no passado. A economia está sendo muito expressiva, empresa integra e relacionamento com o cliente muito ágil, recomendo!`,
      avatar: "https://taxhealthbr.com.br/wp-content/uploads/2023/10/648b6b44ca594370333ee0a1.jpeg"
    },
    {
      id: 4,
      name: "Alana Caroline - Ginecologista e Obstetra",
      role: "",
      content: `Conheci a Tax Health por indicação de um amigo médico também cliente, achei muito interessante a economia e restituição que ele estava usufruindo, fiz o levantamento do meu CNPJ e descobri que minha empresa também possuía as características de direito do benefício fiscal, empresa integra e verdadeiramente preocupada com a saúde financeiro dos seus clientes, estou muito satisfeito com o serviço.`,
      avatar: "https://taxhealthbr.com.br/wp-content/uploads/2023/10/648b6b44ca59435e0c3ee0a2.jpeg"
    },
    {
      id: 5,
      name: "Bárbara Ellen Toledo Gouveia - Ginecologista e Obstetra",
      role: "",
      content: `A migração foi conduzida de forma simples prática e 100% remota, eles organizaram minha empresa e passei a usufruir de reduções tributárias bem expressivas, isso me ajudou muito com o fluxo de caixa, serviço muito bom e personalizado para médicos, tem minha aprovação!`,
      avatar: "https://taxhealthbr.com.br/wp-content/uploads/2023/10/648b6b44ca59431bd03ee09f.jpeg"
    },
    {
      id: 6,
      name: "Jane Helly Resplandes - Ginecologista e Obstetra",
      role: "",
      content: `Descobri que minha empresa tinha direito de um benefício fiscal através de um processo administrativo, consegui solicitar a restituição dos impostos que foram pagos errados nos últimos 60 meses e hoje estou com uma carga tributária aproximadamente 40% menor do que antes, o relacionamento deles é bem personalizados para médicos, recomendo o serviço.`,
      avatar: "https://taxhealthbr.com.br/wp-content/uploads/2023/10/648b6b44ca59431ecc3ee09e.jpeg"
    }
  ];
  return <section id="clientes" className="py-12 md:py-16 px-4 md:px-6 bg-gradient-to-b from-blue-50 to-white scroll-mt-24 md:scroll-mt-28">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Mais de 500 clientes atendidos no Brasil</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">O que dizem nossos clientes?</p>
        </div>
        <div className="mb-6 md:mb-10">
          <VideoTestimonials embedded />
        </div>
        <div className="grid grid-cols-1 gap-6 md:gap-8">
          {testimonials.map(testimonial => <Card key={testimonial.id} className="border-none shadow-sm hover:shadow-md transition-shadow duration-300 h-full overflow-hidden">
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-center mb-4">
                  <Avatar className="h-12 w-12 mr-4 border-2 border-blue-100">
                    <AvatarFallback className="bg-blue-100 text-blue-600">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
                
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400 fill-yellow-400" />)}
                </div>
                
                <blockquote className="text-gray-600 italic flex-grow">
                  "{testimonial.content}"
                </blockquote>
              </CardContent>
            </Card>)}
        </div>
        
        <div className="mt-12 md:mt-16 p-6 md:p-8 bg-blue-600 text-white rounded-2xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-y-6 md:gap-y-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold">R$100M+</div>
              <div className="text-blue-100 mt-2">Economia gerada aos clientes</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold">500+</div>
              <div className="text-blue-100 mt-2">Profissionais atendidos</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold">97%</div>
              <div className="text-blue-100 mt-2">Taxa de sucesso</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Testimonials;